export const mailEllipsisAriaLabelText = "qRa";
export default {mailEllipsisAriaLabelText};